import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';

import { AppContext } from '@prisjakt/ui-app-context';
import AdContainer from '../ads';
import { withAds } from '../ads/context';

import * as S from './styles';

const topAdSpacing = { top: '10px' };
const bottomAdSpacing = { bottom: '10px' };

const renderStaticOutsiderAds = numberOfAds =>
  [
    <AdContainer
      key="skyscraper_1"
      placement="skyscraper_1"
      min={1199}
      max={10000}
      scalable
      scaleBase=".outsider-ads"
    />,
    <AdContainer
      key="skyscraper_2"
      placement="skyscraper_2"
      min={1199}
      max={10000}
      scalable
      scaleBase=".outsider-ads"
    />,
    <AdContainer
      key="skyscraper_3"
      placement="skyscraper_3"
      min={1199}
      max={10000}
      scalable
      scaleBase=".outsider-ads"
    />,
  ].slice(0, numberOfAds);

const PageContent = props => {
  const {
    topPlacements,
    bottomPlacements,
    children,
    adServiceContext,
    adsDelayed,
    wideContent,
  } = props;

  const { market, renderMode } = useContext(AppContext);
  const adsActive = market && market.ads && market.ads.active;
  const responsiveMode = !['desktop', 'native', 'mobile'].includes(renderMode);
  const showAds = props.withAds && adsActive && responsiveMode;
  const takeover = showAds && adServiceContext && adServiceContext.takeover;

  return (
    <S.PageContent
      responsiveMode={responsiveMode}
      data-test={props['data-test']}
    >
      <S.Wrapper>
        {showAds && topPlacements.length > 0 && (
          <S.TopAds takeover={!!takeover} className="top-ads">
            {topPlacements.map((adProps, index) => {
              const placementOptions =
                adServiceContext &&
                adServiceContext.actions &&
                adServiceContext.actions.getPlacementOptions(adProps.placement);

              return (
                <AdContainer
                  {...adProps}
                  key={`${adProps.placement}-${index.toString()}`}
                  isReady={adsDelayed[adProps.placement]}
                  spacing={topAdSpacing}
                  reserveSpace={Boolean(
                    placementOptions && placementOptions.reserveSpace
                  )}
                />
              );
            })}
          </S.TopAds>
        )}
        <S.Content
          takeover={!!takeover}
          hasAds={adsActive}
          wideContent={wideContent}
        >
          {children}
        </S.Content>

        {showAds && bottomPlacements.length > 0 && (
          <aside className="bottom-ads">
            {bottomPlacements.map(adProps => (
              <AdContainer
                {...adProps}
                key={adProps.placement}
                isReady={adsDelayed[adProps.placement]}
                spacing={bottomAdSpacing}
              />
            ))}
          </aside>
        )}
      </S.Wrapper>

      {showAds && (
        <S.OutsiderAds takeover={!!takeover} className="outsider-ads">
          {renderStaticOutsiderAds(3)}
        </S.OutsiderAds>
      )}
    </S.PageContent>
  );
};

const { node, arrayOf, shape, string, number, bool, object } = PropTypes;
const PlacementType = shape({
  placement: string,
  min: number,
  max: number,
});

PageContent.propTypes = {
  children: node,
  topPlacements: arrayOf(PlacementType),
  outsiderPlacements: arrayOf(PlacementType),
  bottomPlacements: arrayOf(PlacementType),
  withAds: bool,
  headerHeight: number,
  adServiceContext: object,
  adsDelayed: object,
  wideContent: bool,
  'data-test': string,
};

PageContent.defaultProps = {
  children: null,
  topPlacements: [
    {
      scalable: true,
      scaleParent: '.top-ads',
      placement: 'panorama_top',
      min: 861,
      max: 10000,
    },
  ],
  outsiderPlacements: [
    {
      placement: 'skyscraper_1',
      min: 1199,
      max: 10000,
      scalable: true,
      scaleBase: '.outsider-ads',
      scaleParent: '.pj-ui-rolling-ad-container--item',
    },
    {
      placement: 'skyscraper_2',
      min: 1199,
      max: 10000,
      scalable: true,
      scaleBase: '.outsider-ads',
      scaleParent: '.pj-ui-rolling-ad-container--item',
    },
    {
      placement: 'skyscraper_3',
      min: 1199,
      max: 10000,
      scalable: true,
      scaleBase: '.outsider-ads',
      scaleParent: '.pj-ui-rolling-ad-container--item',
    },
  ],
  bottomPlacements: [
    { placement: 'panorama_footer', min: 1024, max: 10000 },
    { placement: 'dubbelpanorama3', min: 0, max: 860 },
  ],
  withAds: false,
  headerHeight: undefined,
  adServiceContext: {},
  adsDelayed: {},
  wideContent: false,
  'data-test': undefined,
};

export default withAds(memo(PageContent));
